<script lang="ts">
  import { useThrelte } from '@threlte/core'
  import { selectClickedElement } from './helpers'
  import { sceneMode } from '../../stores/scene-mode'
  import { useKeyboardListener, useMouseEvents } from '../../hooks'
  import useObjectsQueries from '../../routes/project/hooks/useObjectsQueries'
  import { canvasSelection } from '../../stores/canvas-selection'

  const { scene, renderer } = useThrelte()
  const { removeObjectMutation } = useObjectsQueries()

  const onClick = (e: MouseEvent) => {
    selectClickedElement(renderer, e, scene)
  }

  const onRemove = (e: KeyboardEvent) => {
    if ($canvasSelection && e.target === document.body) {
      removeObjectMutation.mutate($canvasSelection.uuid)
    }
  }

  $effect(() => {
    if (
      $sceneMode === 'default'
      || $sceneMode === 'translate'
      || $sceneMode === 'rotate'
    ) {
      const mouseEventsListener = useMouseEvents({ onClick })
      const removeItemListener = useKeyboardListener(['Backspace', 'Delete'], {
        onKeyUp: onRemove,
      })

      return () => {
        mouseEventsListener()
        removeItemListener()
      }
    }
  })
</script>
